export enum FieldTypesEnum {
  Text = 'text',
  Number = 'number',
  Date = 'date',
  Boolean = 'boolean',
  Json = 'json',
}
